<div class="body-layout">
    <div class="body-overlay"></div>
    <!-- BEGIN: Header -->
    <app-header></app-header>

    <div class="main">
        <app-left-side-menu></app-left-side-menu>
        <div class="content" (scroll)="scrolling($event)">
            <!-- breadcrumb  -->
            <!-- <breadcrumb></breadcrumb> -->
            <!-- <ul class="change-color">
          <li data-color="light"></li>
          <li data-color="dark"></li>
  
        </ul>
        <div class="form-group checkbox">
  
          <div class="form-input">
  
            <p-radioButton name="customerMode" (click)="customerModeChanged('default'); default()" [(ngModel)]="isColor"
              value="Color" label="default " class="pr-2">
            </p-radioButton>
            <p-radioButton name="customerMode" (click)="customerModeChanged('dark'); dark()" [(ngModel)]="isColor"
              value="dark" label="dark " class="pl-2">
            </p-radioButton>
            <p-radioButton name="customerMode" (click)="customerModeChanged('custom')" [(ngModel)]="isColor"
              value="custom" label="custom" class="pl-2">
            </p-radioButton>
  
          </div>
        </div>
  
        <div class="tools" *ngIf="isColor==='custom'">
  
          <label for="color-picker-primary">Primary colour</label>
          <input type="color" id="color-picker-background" value="#b30027" (change)='background($event)'>
          <label for="color-picker-contrast">Contrast colour</label>
          <input type="color" id="color-picker" value="#ffffff" (change)='color($event)'>
        </div> -->

            <router-outlet></router-outlet>
        </div>
    </div>

</div>